import Typography from "antd/es/typography/Typography";
import React, { useEffect, useRef, useState } from "react";
import CustomButton from "../../../resuableComponents/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import { selectDarkColor } from "../../../../slices/PaymentSessionDetailsSlice";
import { buildPaymentRequest, handleFormatDiscount } from "../../../../Utils/paymentUtils";
import {
  initiatePayment,
  resetPaymentInitiation,
} from "../../../../slices/PaymentInitiationSlice";
import timer_worker_script from "../../../../web-workers/timerWorker";
import { formatOtpTime } from "../../../../Utils/utils";
import {
  selectActivePaymentMethod,
  changeActivePaymentMethod,
} from "../../../../slices/PaymentButtonSlice";
import {
  methodSelectedEvent,
  paymentInitiatedEvent,
} from "../../../../Utils/uiAnalytics";
import { handleTotalPaymentSummaryError } from "../../../../slices/HandleAdditionalComponentsSlice";
import TranslateText from "../../../resuableComponents/TranslateText";
import { useTranslation } from "react-i18next";
import PyamentButton from "../../paymentButton/PaymentButton";
import ErrorModal from "../../../../ant-design/components/modals/errorModal/ErrorModal";
import { InfoCircleOutlined } from "@ant-design/icons";
import "../Upi/upi.css";
import { startAutoRefund } from "../../../../slices/AutoRefundSlice";

const QrisQr = ({ qrisData }) => {
  const { t } = useTranslation()
  const darkcolor = useSelector((state) => selectDarkColor(state));
  const updatedShopperDetails = useSelector((state) => state.paymentSessionDetails.updatedShopperDetails);
  const paymentInitiationData = useSelector((state) => {
    let data = state.paymentInitiation.paymentInitiationData;
    return data;
  });
  const sessionDetails = useSelector((state) => state.paymentSessionDetails.sessionDetails);
  const defaultDuration = 300;
  const expiryDuration =
    paymentInitiationData?.actions?.length > 0
      ? paymentInitiationData?.actions[0]?.expirySec
      : null;
  const duration = expiryDuration || defaultDuration;
  const [countdown, setCountdown] = useState(duration);
  const dispatch = useDispatch();
  const [qrActive, setQrActive] = useState(0);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const activePaymentMethod = useSelector((state) => selectActivePaymentMethod(state));
  const showTotalPaymentSummaryField = useSelector((state) => state.additionalComponents.showTotalPaymentSummaryField);
  const timerRef = useRef(null);
  const paymentInitiationLoading = useSelector((state) => state.paymentInitiation.paymentInitiationLoading);
  const totalPaymentSummaryValue = useSelector((state) => state.additionalComponents.totalPaymentSummaryValue);
  const appliedOfferDetail = useSelector(state => state.offers.appliedOfferDetail)
  const activeSurchargeDetail = useSelector(state => state.surcharges.activeSurchargeDetail);
  const surchargeCodes = activeSurchargeDetail?.length ? activeSurchargeDetail?.map(el => el.surchargeDetails?.surchargeCode) : []

  const stopTimer = () => {
    if (timerRef.current) {
      timerRef.current.postMessage({ action: "stop" });
      timerRef.current.terminate();
      timerRef.current = null;
    }
  };

  useEffect(() => {
    if (activePaymentMethod !== "QrisQr") {
      stopTimer();
      setCountdown(defaultDuration);
      setQrActive(0);
    }
  }, [activePaymentMethod]);

  useEffect(() => {
    if (
      paymentInitiationData != null &&
      paymentInitiationData?.paymentMethod?.brand === "QrisQr"
    ) {
      if (paymentInitiationData?.actions?.length === 0) {
        setShowErrorModal(true);
        return;
      }

      setQrActive(1);
      const expiryDuration =
        paymentInitiationData?.actions?.length > 0
          ? paymentInitiationData?.actions[0]?.expirySec
          : defaultDuration;

      stopTimer();
      setCountdown(expiryDuration);
      timerRef.current = new Worker(timer_worker_script);
      timerRef.current.postMessage({
        action: "start",
        duration: expiryDuration,
      });
      timerRef.current.onmessage = async ({ data }) => {
        if (data === "done") {
          setCountdown(expiryDuration);
          setQrActive(2);
          stopTimer();
          // with auto refund on, the auto refund loader takes over the checkout. Otherwise the QR expires as before.
          if (!(await dispatch(startAutoRefund(paymentInitiationData?.transactionId)))) {
            dispatch(resetPaymentInitiation());
          }
        } else if (data !== "stopped") {
          setCountdown(data);
        }
      };
    } else {
      stopTimer();
      setQrActive(0);
    }

    return () => {
      stopTimer();
    };
  }, [paymentInitiationData]);

  const handleQrPay = () => {
    let paymentRequest = buildPaymentRequest(
      qrisData?.instrumentTypeValue,
      updatedShopperDetails,
      sessionDetails,
      "",
      appliedOfferDetail?.codes,
      surchargeCodes
    );
    if (totalPaymentSummaryValue) {
      paymentRequest.payload.money = {
        amount: totalPaymentSummaryValue,
        currencyCode: sessionDetails?.paymentDetails?.money?.currencyCode,
      };
    }
    let token = paymentRequest?.token;
    let payload = paymentRequest?.payload;
    methodSelectedEvent("QRIS", "QrisQr");
    if (showTotalPaymentSummaryField && totalPaymentSummaryValue === "") {
      dispatch(handleTotalPaymentSummaryError("Please enter amount"));
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      dispatch(initiatePayment({ token, payload }));
      paymentInitiatedEvent("QRIS", "QrisQr");
    }
  };

  const handleCallFormatDiscount = (type, callback) => {
    handleFormatDiscount({
      type,
      callback,
      dispatch,
      sessionDetails,
      appliedOfferDetail,
      showTotalPaymentSummaryField,
      totalPaymentSummaryValue
    });
  }
  const handlePrimaryClick = () => {
    setShowErrorModal(false)
    stopTimer();
    setQrActive(1);
    dispatch(resetPaymentInitiation());
  }

  const style = {
    background: `linear-gradient(to right, ${darkcolor} 4px, transparent 4px) 0 0 , linear-gradient(to right, ${darkcolor} 4px, transparent 4px) 0 100% , linear-gradient(to left, ${darkcolor} 4px, transparent 4px) 100% 0,linear-gradient(to left, ${darkcolor} 4px, transparent 4px) 100% 100%,linear-gradient(to bottom, ${darkcolor} 4px, transparent 4px) 0 0,linear-gradient(to bottom, ${darkcolor} 4px, transparent 4px) 100% 0,linear-gradient(to top, ${darkcolor} 4px, transparent 4px) 0 100%,linear-gradient(to top, ${darkcolor} 4px, transparent 4px) 100% 100%`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "20px 20px",
  };

  return (
    <div className="upi-qr-root">
      <div className="qr-code-btn">
        <div className="qr" style={style}>
          <img
            src={
              paymentInitiationData &&
                paymentInitiationData?.actions?.length > 0
                ? `data:image/gif;base64,${paymentInitiationData?.actions[0]?.content}`
                : "/assets/intent/qr.png"
            }
            style={{
              filter:
                qrActive === 0 || qrActive === 2 || !qrActive
                  ? "blur(3px)"
                  : "",
              width: "150px",
              height: "150px",
            }}
          />
        </div>
        <div
          className="generate-qr"
          style={{
            display: qrActive === 1 ? "none" : "",
          }}
        >
          <CustomButton
            text={qrActive === 0 ? t("VIEW") : t("REFRESH")}
            containerType={"default"}
            block={true}
            loading={paymentInitiationLoading}
            padding={"4px 12px"}
            onClick={() => {
              handleCallFormatDiscount("QRIS", handleQrPay)
              dispatch(changeActivePaymentMethod("QrisQr"));
            }}
          />
        </div>
      </div>
      <div className="qr-desc">
        <Typography
          className="regular12Heading dynamic-font-family"
          style={{ color: "var(-Neutral-Grey-1100)" }}
        >
          <TranslateText label={"SCAN_QR_USING_QRIS_APP"}>Scan the QR using any QRIS supported app</TranslateText>
        </Typography>
        <div className="upi-app-img-section">
          {qrisData?.logoUrl && (
            <img src={qrisData.logoUrl} width={15} height={13} />
          )}
        </div>
        {paymentInitiationData != null && (
          <div>
            <Typography
              className="regular12Heading dynamic-font-family"
              style={{ color: "var(-Neutral-Grey-1100)" }}
            >
              <TranslateText label={"QR_CODE_VALID_FOR"}>QR Code is valid for</TranslateText>
            </Typography>{" "}
            <Typography className="regular12Heading dynamic-font-family">
              <span
                className="semiBold12Heading dynamic-font-family"
                style={{ color: "var(--Red-800)" }}
              >
                {formatOtpTime(countdown)}{" "}
              </span>
              <TranslateText label={"MINUTES"}>minutes</TranslateText>
            </Typography>
          </div>
        )}
      </div>
      <div className="upiQrPayButton">
        <PyamentButton />
      </div>

      {
        showErrorModal && (
          <ErrorModal
            icon={
              <InfoCircleOutlined style={{ color: "#FF4D4F", fontSize: "22px" }} />
            }
            title={`${t("UNABLE_TO_LOAD_QR")}`}
            desc={t("UNABLE_TO_LOAD_QR_DESC")}
            showModal={showErrorModal}
            primaryOnClick={() => { handlePrimaryClick() }}
            primaryBtnText={`${t("Ok")}`}
            showSecondaryButton={false}
          />
        )
      }
    </div>
  );
};

export default QrisQr;
